export default __webpack_public_path__ + "static/media/ads-video-popular-events.06139189.mp4";